import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { useLocation } from "@reach/router";

const Seo = ({ meta, hardcodedMeta = [], canonical }) => {
  const location = useLocation();

  const { hostname, protocol } = new URL(
    canonical || process.env.GATSBY_SITE_URL
  );

  // If a custom canonical URL is not defined we fallback to the default canonical URL
  const href =
    canonical || `${process.env.GATSBY_SITE_URL}${location.pathname}`;

  const {
    site: {
      siteMetadata: { title },
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const prismicTitle = meta?.document?.data?.title;

  const getTypeText = {
    html5: ({ key, text }) => ({ name: key, content: text }),
    opengraph: ({ key, text }) => ({ property: key, content: text }),
  };

  const getTypeLink = {
    html5: ({ key, link: { url } }) => ({ name: key, content: url }),
    opengraph: ({ key, link: { url } }) => ({ property: key, content: url }),
  };

  const getMeta = {
    text: (items) => items.map((item) => getTypeText[item.type](item)),
    link: (items) => items.map((item) => getTypeLink[item.type](item)),
  };

  const metaTags = meta?.document
    ? meta.document.data.body.reduce(
        (acc, { slice_type: sliceType, items }) => {
          return [...acc, ...getMeta[sliceType](items)];
        },
        []
      )
    : [];

  return (
    <>
      <title>{prismicTitle || title}</title>

      <link
        rel="canonical"
        href={href}
        data-baseprotocol={protocol}
        data-basehost={hostname}
      />

      {metaTags?.map((metaTag, index) => (
        <meta
          key={`${index}=${metaTag.name}`}
          name={metaTag.name}
          content={metaTag.content}
        />
      ))}

      {hardcodedMeta?.map((metaTag, index) => (
        <meta
          key={`${index}=${metaTag.name}`}
          name={metaTag.name}
          content={metaTag.content}
        />
      ))}
    </>
  );
};

export default Seo;
